import { all, takeEvery, put } from 'redux-saga/effects';
import siteConfig from '@iso/config/site.config';
import actions from './actions';
import { notification } from '@iso/components';
const gaxios = require('gaxios');
gaxios.instance.defaults = {
    baseURL: siteConfig.siteUrl.API_URL
}

export function* getCotizaciones() {
    const res = yield gaxios.request({
        url: 'api/cotizaciones',
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        yield put({
            type: actions.GET_COTIZACIONES_SUCCESS,
            payload: res.data.cotizaciones,
        });
    }
}
export function* createCotizacion({ payload }) {
    const res = yield gaxios.request({
        url: 'api/cotizaciones',
        method: 'POST',
        data: payload,
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        yield put({ type: actions.CREATE_COTIZACION_SUCCESS, payload: res.data.cotizacion });
    }
}
export function* editCotizacion({ payload }) {
    const res = yield gaxios.request({
        url: 'api/cotizaciones/' + payload._id,
        method: 'PUT',
        data: payload,
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        yield put({ type: actions.EDIT_COTIZACION_SUCCESS, payload: res.data.cotizacion });
    }
}
export function* deleteCotizacion({ payload }) {
    const res = yield gaxios.request({
        url: 'api/cotizaciones/' + payload,
        method: 'DELETE',
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        yield put({ type: actions.DELETE_COTIZACION_SUCCESS, payload });
    }
}

export function* sendCotizacionesByEmail({ payload }) {
    const res = yield gaxios.request({
        url: 'api/cotizaciones/email/',
        method: 'POST',
        data: payload,
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
    }
}

export default function* rootSaga() {
    yield all([
        yield takeEvery(actions.GET_COTIZACIONES_REQUEST, getCotizaciones),
        yield takeEvery(actions.CREATE_COTIZACION_REQUEST, createCotizacion),
        yield takeEvery(actions.EDIT_COTIZACION_REQUEST, editCotizacion),
        yield takeEvery(actions.DELETE_COTIZACION_REQUEST, deleteCotizacion),
        yield takeEvery(actions.SEND_COTIZACION_BY_EMAIL, sendCotizacionesByEmail)
    ]);
}
